var map = {
	"./Logo Jack Richards.png": "KzNq",
	"./Logo Palletways.png": "4pfu",
	"./Logo Yelovest.png": "HOg5",
	"./facebook.png": "smkH",
	"./instagram.png": "4CYd",
	"./linkedin.png": "zOWB",
	"./logo_lgv-drivers-choice.png": "QwYh",
	"./twitter.png": "RX7p",
	"./youtube.png": "2XzC"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1IgP";